const s = {
  name: "EmailLockRestart",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,28.8V3.2l7.3,6.5l1.3-1.5L3.6,2h32.8l-7,6.3l1.3,1.5L38,3.2V16h2V3c0-1.7-1.3-3-3-3H3C1.3,0,0,1.3,0,3v26
			c0,1.7,1.3,3,3,3h19v-2H3.6l7-6.3l-1.3-1.5L2,28.8z"/>
		<path class="st0" d="M32,25v3h2v-3H32z"/>
		<path class="st0" d="M40,21h-3v-1c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4v1h-3v11h14V21z M28,23h10v7H28V23z M35,20v1h-4v-1
			c0-1.1,0.9-2,2-2S35,18.9,35,20z"/>
		<path class="st0" d="M10.3,16.7l1.4-1.4l2.3,2.3V16c0-3.3,2.7-6,6-6s6,2.7,6,6s-2.7,6-6,6v-2c2.2,0,4-1.8,4-4s-1.8-4-4-4
			s-4,1.8-4,4v1.6l2.3-2.3l1.4,1.4L15,21.4L10.3,16.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as EmailLockRestart
};
